'use client';

import { useClickOutside } from '@wishket/yogokit';
import { usePathname, useRouter } from 'next/navigation';
import { useState, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

import ScrapBox from '../ScrapBox';

import {
  ScrapTooltipButton,
  UpdatableScrapButton,
} from './ScrapIconButton.parts';

import { useAuth } from '@/shared/hooks';
import { PATH } from '@/shared/constants';
interface ScrapIconButtonProps {
  id: number;
  initialIsScrapped?: boolean;
  isScrapBoxPositionLeft?: boolean;
  scrapBoxPositionClass?: string;
  authorHref?: string;
}

const ScrapIconButton = ({
  id,
  initialIsScrapped,
  isScrapBoxPositionLeft = false,
  scrapBoxPositionClass = '',
  authorHref = '',
}: ScrapIconButtonProps) => {
  const { isAuth } = useAuth();
  const router = useRouter();
  const pathname = usePathname();
  const [isScrapBoxOpen, setIsScrapBoxOpen] = useState(false);
  const scrapBoxRef = useRef<HTMLDivElement>(null);
  const isAuthorProfile = pathname.includes(`${PATH.HOME}/@`);
  const authorUrlIdentifier = isAuthorProfile
    ? authorHref.split('@')[1]
    : undefined;
  const [isUpdatableScrapButton, setIsUpdatableScrapButton] = useState(
    initialIsScrapped === undefined
  );

  const openScrapBox = () => {
    if (!isUpdatableScrapButton) {
      setIsUpdatableScrapButton(true);
    }
    if (!isAuth) {
      router.push(`${PATH.AUTH_LOGIN}?next=${pathname}`);
      return;
    }
    setIsScrapBoxOpen(true);
  };

  const closeScrapBox = () => {
    setIsScrapBoxOpen(false);
  };

  useClickOutside(scrapBoxRef, closeScrapBox);

  return (
    <>
      {isUpdatableScrapButton ? (
        <UpdatableScrapButton
          id={id}
          initialIsScrapped={!!initialIsScrapped}
          onClick={openScrapBox}
        />
      ) : (
        <ScrapTooltipButton
          isScrapped={!!initialIsScrapped}
          onClick={openScrapBox}
        />
      )}

      <ScrapBox
        className={twMerge(
          'absolute right-[158px] top-full z-30 mt-2 w-[240px] desktop:z-20',
          isScrapBoxPositionLeft && 'right-[196px]',
          scrapBoxPositionClass
        )}
        scrapBoxRef={scrapBoxRef}
        articleId={id}
        isOpen={isScrapBoxOpen}
        onClose={closeScrapBox}
        urlIdentifier={authorUrlIdentifier}
      />
    </>
  );
};

export default ScrapIconButton;
